import React from "react";
import classNames from "classnames";
import { Button } from ".";

interface ButtonGroupProps {
    variant?: string;
    color?: string;
    size?: string;

    align?: "" | "center" | "start" | "end";
    vertical?: boolean;
    className?: string;
    children?: any;
    [x: string]: any;
}

export const ButtonGroup = ({ variant, color, size, align, vertical, className, children, ...props }: ButtonGroupProps) => {
    var cn = classNames(className, {
        "justify-content-start": align === "start",
        "justify-content-end": align === "end",
        "justify-content-center": align === "center",
        "flex-column": vertical,
        "shadow-2": variant == "contained",
        "btn-group": !vertical,
        "btn-group-vertical": vertical,
    });

    const MapChildren = (children: React.ReactNode) =>
        React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) return child;
            var x: any = child;
            if (x?.type === Button) {
                let newProps = { variant, color, size, ...child.props, children: MapChildren(child.props?.children) };
                return React.cloneElement(child, newProps);
            }

            return !child.props?.children
                ? child
                : React.cloneElement(child, { ...child.props, children: MapChildren(child.props.children) });
            return child;
        });

    return (
        <div className={cn} {...props}>
            {MapChildren(children)}
        </div>
    );
};
